var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"tw-mt-6 tw-mb-4 leavedates-header-logo",attrs:{"src":require("./../assets/icons/leavedates-logo.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }